var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { setEmbedPanelVisible } from "./embed-display";
import { emitTelemetryError, replayTelemetry, telemetryIframeId, } from "./embed-telemetry";
import { buildOptions, embedApiVersion, readState, } from "./piab-state";
import { OpsExecutor, systemSignature, waitFor, } from "./piab-ops";
import { CameraViewId } from "3d/types";
import { actions } from "store/actions";
export var SNAPSHOT_WIDTH = 640;
export var SNAPSHOT_QUALITY = 0.6;
/** The app's camera transitions take 0.5 s (setNextView(..., 0.5)); allow for a frame or two more. */
var CAMERA_SETTLE_MS = 750;
function formatError(error) {
    if (error instanceof Error && error.message)
        return error.message;
    var e = error;
    return (e === null || e === void 0 ? void 0 : e.message) || String(error);
}
var EmbedApi = /** @class */ (function () {
    function EmbedApi() {
        var _this = this;
        this._queue = Promise.resolve();
        this._applying = 0;
        this._readySent = false;
        this._lastSignature = "";
        this._lastPerformance = false;
        this._lastIssues = "";
        this._configurationFor = "";
        this._configurationFailures = 0;
        this._onMessage = function (event) {
            var _a;
            var data = event.data;
            if (!data || typeof data !== "object" || data.api !== embedApiVersion)
                return;
            switch (data.type) {
                case "configure":
                    _this._enqueue(function () {
                        return _this._configure(event.source, data.requestId, data.changes, typeof data.deadline === "number" ? data.deadline : undefined);
                    });
                    break;
                case "reset":
                    _this._enqueue(function () {
                        return _this._run(event.source, data.requestId, [
                            { op: "clear", parameters: true },
                        ]);
                    });
                    break;
                case "snapshot":
                    _this._enqueue(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this._applying++;
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, , 3, 4]);
                                    return [4 /*yield*/, this._sendState(event.source, data.requestId, [], [])];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    this._applying--;
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    break;
                case "displayMode":
                    setEmbedPanelVisible(data.mode === "fullscreen");
                    break;
                case "camera":
                    (_a = _this._executor) === null || _a === void 0 ? void 0 : _a.camera(data.preset);
                    break;
                case "ping":
                    _this.sendReady(event.source);
                    replayTelemetry(event.source);
                    break;
                default:
                    console.warn("[embed] unknown message", data);
            }
        };
        window.addEventListener("message", this._onMessage);
    }
    EmbedApi.prototype.dispose = function () {
        var _a;
        window.removeEventListener("message", this._onMessage);
        (_a = this._unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    /** Called by the React bridge whenever the store or the PlayCanvas pieces (re)appear. */
    EmbedApi.prototype.attach = function (att) {
        var _this = this;
        var _a, _b;
        var storeChanged = att.store !== ((_a = this._att) === null || _a === void 0 ? void 0 : _a.store);
        this._att = att;
        if (storeChanged || !this._executor) {
            this._executor = new OpsExecutor(att.store, {
                onSceneChanged: function () { return undefined; },
            });
            (_b = this._unsubscribe) === null || _b === void 0 ? void 0 : _b.call(this);
            this._unsubscribe = att.store.subscribe(function () { return _this._onStoreChange(); });
            this._readySent = false;
            void this._waitReady();
        }
    };
    Object.defineProperty(EmbedApi.prototype, "attached", {
        get: function () {
            return !!this._att;
        },
        enumerable: false,
        configurable: true
    });
    EmbedApi.prototype._waitReady = function () {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            var store, ok;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = (_a = this._att) === null || _a === void 0 ? void 0 : _a.store;
                        if (!store)
                            return [2 /*return*/];
                        return [4 /*yield*/, waitFor(function () {
                                var s = store.getState();
                                return (!!s.systemDataDefineParameters.dataState.data &&
                                    !s.systemDataDefineParameters.dataState.isLoading);
                            }, 60000, 100)];
                    case 1:
                        ok = _c.sent();
                        if (!ok) {
                            emitTelemetryError("embed: Tacton data did not load within 60 s");
                            return [2 /*return*/];
                        }
                        if (((_b = this._att) === null || _b === void 0 ? void 0 : _b.store) !== store || this._readySent)
                            return [2 /*return*/];
                        this._readySent = true;
                        /* The card shows the 3D perspective, not the app's locked top-down edit view. */
                        try {
                            store.dispatch(actions.setCameraView(CameraViewId.INITIAL_3D_VIEW));
                        }
                        catch (_d) {
                            /* ignore */
                        }
                        this.sendReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------------------------------------------------------- */
    /* state                                                             */
    /* ---------------------------------------------------------------- */
    EmbedApi.prototype.state = function () {
        if (!this._att)
            throw new Error("embed api not attached");
        var s = readState(this._att.store.getState());
        if (this._configuration && this._configurationFor === systemSignature(s))
            s.configuration = this._configuration;
        return s;
    };
    EmbedApi.prototype.sendReady = function (target) {
        if (!this._att)
            return;
        var state = this.state();
        this._remember(state);
        this._post({
            api: embedApiVersion,
            type: "ready",
            state: state,
            options: buildOptions(this._att.store.getState()),
            iframeId: telemetryIframeId,
        }, target);
    };
    EmbedApi.prototype._remember = function (state) {
        this._lastSignature = systemSignature(state);
        this._lastPerformance = !!state.performance;
        this._lastIssues = state.issues.join("|");
    };
    /** Store subscription: debounced unsolicited `state` after edits in the fullscreen UI. */
    EmbedApi.prototype._onStoreChange = function () {
        var _this = this;
        if (this._applying > 0 || !this._readySent)
            return;
        clearTimeout(this._notifyTimer);
        this._notifyTimer = setTimeout(function () {
            if (_this._applying > 0 || !_this._att)
                return;
            var s = _this._att.store.getState();
            if (s.systemDataDefineParameters.dataState.isLoading ||
                s.systemPerformance.isLoading)
                return;
            var state = _this.state();
            var sig = systemSignature(state);
            if (sig === _this._lastSignature &&
                !!state.performance === _this._lastPerformance &&
                state.issues.join("|") === _this._lastIssues)
                return;
            _this._remember(state);
            void _this._sendState(undefined, undefined, ["edited in the configurator"], [], undefined, false);
        }, 600);
    };
    /* ---------------------------------------------------------------- */
    /* snapshot                                                          */
    /* ---------------------------------------------------------------- */
    EmbedApi.prototype.snapshot = function () {
        var _a, _b;
        try {
            var canvas = (_a = this._att) === null || _a === void 0 ? void 0 : _a.canvas;
            var app = (_b = this._att) === null || _b === void 0 ? void 0 : _b.app;
            if (!canvas || !app || canvas.width === 0 || canvas.height === 0)
                return undefined;
            /* preserveDrawingBuffer is off: render and copy in the same task (as the app's own generateScreenshot does). */
            app.render();
            var w = Math.min(SNAPSHOT_WIDTH, canvas.width);
            var h = Math.max(1, Math.round((canvas.height * w) / canvas.width));
            var out = document.createElement("canvas");
            out.width = w;
            out.height = h;
            var ctx = out.getContext("2d");
            if (!ctx)
                return undefined;
            ctx.fillStyle = "#3a3a3a";
            ctx.fillRect(0, 0, w, h);
            ctx.drawImage(canvas, 0, 0, w, h);
            var url = out.toDataURL("image/jpeg", SNAPSHOT_QUALITY);
            var comma = url.indexOf(",");
            if (!url.startsWith("data:image/jpeg") || comma < 0)
                return undefined;
            return { mime: "image/jpeg", data: url.slice(comma + 1), w: w, h: h };
        }
        catch (error) {
            console.debug("[embed] snapshot failed", error);
            return undefined;
        }
    };
    EmbedApi.prototype._settleCamera = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var moving;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        moving = (_a = this._att) === null || _a === void 0 ? void 0 : _a.isCameraMoving;
                        return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, 120); })];
                    case 1:
                        _b.sent();
                        if (!moving) return [3 /*break*/, 3];
                        return [4 /*yield*/, waitFor(function () { return !moving(); }, CAMERA_SETTLE_MS + 1500, 50)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, CAMERA_SETTLE_MS); })];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [4 /*yield*/, new Promise(function (resolve) {
                            var done = false;
                            var finish = function () {
                                if (!done) {
                                    done = true;
                                    resolve();
                                }
                            };
                            requestAnimationFrame(function () { return requestAnimationFrame(finish); });
                            setTimeout(finish, 150);
                        })];
                    case 6:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* ---------------------------------------------------------------- */
    /* messaging                                                         */
    /* ---------------------------------------------------------------- */
    EmbedApi.prototype._post = function (message, target) {
        var _a;
        var destination = (_a = target) !== null && _a !== void 0 ? _a : (window.parent !== window ? window.parent : undefined);
        if (!destination)
            return;
        destination.postMessage(message, "*");
    };
    EmbedApi.prototype._sendState = function (target, requestId, changed, consequences, error, settle) {
        if (settle === void 0) { settle = true; }
        return __awaiter(this, void 0, Promise, function () {
            var state, message, snapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!settle) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._settleCamera()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this._saveConfigurationIfNeeded()];
                    case 3:
                        _a.sent();
                        state = this.state();
                        this._remember(state);
                        message = {
                            api: embedApiVersion,
                            type: "state",
                            state: state,
                            changed: changed,
                            consequences: consequences,
                        };
                        if (requestId !== undefined)
                            message.requestId = requestId;
                        if (error)
                            message.error = error;
                        snapshot = this.snapshot();
                        if (snapshot)
                            message.snapshot = snapshot;
                        this._post(message, target);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** OVM configuration id for the /open link (best effort, only when the system changed; gives up after 2 failures). */
    EmbedApi.prototype._saveConfigurationIfNeeded = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var save, sig, id, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        save = (_a = this._att) === null || _a === void 0 ? void 0 : _a.saveConfiguration;
                        if (!save || this._configurationFailures >= 2)
                            return [2 /*return*/];
                        sig = systemSignature(readState(this._att.store.getState()));
                        if (sig === this._configurationFor && this._configuration)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.race([
                                save(),
                                new Promise(function (r) { return setTimeout(function () { return r(undefined); }, 4000); }),
                            ])];
                    case 2:
                        id = _b.sent();
                        if (id) {
                            this._configuration = id;
                            this._configurationFor = sig;
                            this._configurationFailures = 0;
                        }
                        else {
                            this._configurationFailures++;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this._configurationFailures++;
                        console.debug("[embed] saveConfiguration failed", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EmbedApi.prototype._enqueue = function (task) {
        this._queue = this._queue.then(task).catch(function (error) {
            console.error("[embed] task failed", error);
            emitTelemetryError("embed task: ".concat(formatError(error)));
        });
    };
    EmbedApi.prototype._waitAttached = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, waitFor(function () { return !!_this._executor && _this._readySent; }, 90000, 100)];
            });
        });
    };
    EmbedApi.prototype._configure = function (source, requestId, changes, deadline) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var full, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(deadline && Date.now() > deadline)) return [3 /*break*/, 2];
                        // Queued behind other work (or the document was hidden) past the server's hard cap: never apply stale ops.
                        return [4 /*yield*/, this._sendState(source, requestId, [], [], "aborted: the request's deadline passed ".concat(Math.round((Date.now() - deadline) / 1000), " s before it could start (the view was hidden or busy); nothing applied"), false)];
                    case 1:
                        // Queued behind other work (or the document was hidden) past the server's hard cap: never apply stale ops.
                        _b.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this._waitAttached()];
                    case 3:
                        if (!(_b.sent())) {
                            this._post({
                                api: embedApiVersion,
                                type: "state",
                                requestId: requestId,
                                state: null,
                                changed: [],
                                consequences: [],
                                error: "the client is not ready (Tacton data not loaded)",
                            }, source);
                            return [2 /*return*/];
                        }
                        if (!(!changes || typeof changes !== "object")) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._sendState(source, requestId, [], [], "changes must be an object with ops or a full state", false)];
                    case 4:
                        _b.sent();
                        return [2 /*return*/];
                    case 5:
                        if (!Array.isArray(changes.ops)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this._run(source, requestId, changes.ops, deadline)];
                    case 6:
                        _b.sent();
                        return [2 /*return*/];
                    case 7:
                        full = ((_a = changes.system) !== null && _a !== void 0 ? _a : changes);
                        if (!Array.isArray(full.grips)) return [3 /*break*/, 13];
                        /* _applying stays raised until the reply is out: the deselect/camera dispatches of _afterOps and the
                         * settle wait would otherwise trip the "edited in the configurator" debounce (found by e2e 2026-09-08). */
                        this._applying++;
                        _b.label = 8;
                    case 8:
                        _b.trys.push([8, , 11, 12]);
                        return [4 /*yield*/, this._executor.loadState(full)];
                    case 9:
                        result = _b.sent();
                        this._afterOps();
                        return [4 /*yield*/, this._sendState(source, requestId, result.changed, result.consequences, result.errors.length ? result.errors.join("; ") : undefined, result.changed.length > 0)];
                    case 10:
                        _b.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        this._applying--;
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                    case 13: return [4 /*yield*/, this._sendState(source, requestId, [], [], "changes must contain ops[] or a full state with grips[]", false)];
                    case 14:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EmbedApi.prototype._run = function (source, requestId, ops, deadline) {
        return __awaiter(this, void 0, Promise, function () {
            var result, cameraOp;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._applying++;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 4, 5]);
                        return [4 /*yield*/, this._executor.apply(ops, {
                                deadline: deadline,
                                onProgress: function (op, of, label) {
                                    return _this._post({
                                        api: embedApiVersion,
                                        type: "progress",
                                        requestId: requestId,
                                        op: op,
                                        of: of,
                                        label: label,
                                        t: Date.now(),
                                    }, source);
                                },
                            })];
                    case 2:
                        result = _a.sent();
                        cameraOp = ops.some(function (o) { return o.op === "camera"; });
                        if (!cameraOp)
                            this._afterOps();
                        if (result.errors.length)
                            emitTelemetryError("configure: ".concat(result.errors.join("; ")));
                        return [4 /*yield*/, this._sendState(source, requestId, result.changed, result.consequences, result.errors.length ? result.errors.join("; ") : undefined, true)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        this._applying--;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /** After a batch: deselect (the app selects new nodes and opens its menu) and show the 3D perspective. */
    EmbedApi.prototype._afterOps = function () {
        var _a, _b;
        try {
            (_a = this._att) === null || _a === void 0 ? void 0 : _a.store.dispatch(actions.deselectEntities());
            (_b = this._att) === null || _b === void 0 ? void 0 : _b.store.dispatch(actions.setCameraView(CameraViewId.INITIAL_3D_VIEW));
        }
        catch (_c) {
            /* ignore */
        }
    };
    return EmbedApi;
}());
export { EmbedApi };
var singleton;
/** The one EmbedApi of this document (created on first use). */
export function getEmbedApi() {
    if (!singleton) {
        singleton = new EmbedApi();
        window.__piabEmbed = singleton;
    }
    return singleton;
}
